var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRiskHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10916_28334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9966 6.92006C14.0713 8.13679 14.6651 9.70386 14.6666 11.3273L12.2603 11.3295C12.2593 10.292 11.8799 9.29059 11.1931 8.51302L12.9966 6.92006Z",
    fill: "#F6475D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 11.3334C1.33325 9.71001 1.92561 8.1424 2.99918 6.92467L4.80416 8.51597C4.11808 9.29417 3.73954 10.296 3.73954 11.3334H1.33325Z",
    fill: "#F6475D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55094 6.36843C4.75996 5.28506 6.32275 4.68007 7.94609 4.66697C9.56944 4.65386 11.1418 5.23353 12.3681 6.29724L10.7915 8.11501C10.0078 7.43524 9.00293 7.06479 7.96552 7.07317C6.92811 7.08155 5.9294 7.46817 5.15677 8.16051L3.55094 6.36843Z",
    fill: "#F6475D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1,
    fill: "#F6475D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10L7.50012 10.5002L7.99998 11.5L11.5 10Z",
    fill: "#F6475D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10916_28334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskHigh);
export default __webpack_public_path__ + "static/media/risk-high.5f8fc973b2489f101550943ac78c10c6.svg";
export { ForwardRef as ReactComponent };